module.exports = {
      id: "icon-headset-usage",
      viewBox: "0 0 14.219 15.009",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#icon-headset",
      toString: function () {
        return this.url;
      }
    }